import { createSelector } from 'reselect'

/**
 * Select the sheet state slice
 * @param {object} state - Redux state
 * @returns {object} Sheet state
 */
export const selectSheet = (state) => state.sheet

/**
 * Select the active action sheet
 * @param {object} state - Redux state
 * @returns {object|null} Action sheet data
 */
export const selectActionSheet = createSelector(
  selectSheet,
  (sheet) => sheet.actionSheet
)
